if (!customElements.get('section-announcement-bar')) {
  class TG_SectionAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this._rotatorInterval = null;
      this._currentIndex = 0;
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);
      this.options = JSON.parse(this.getAttribute('data-section-settings'));
      document.documentElement.style.setProperty('--tg-announcement-bar-height', this.offsetHeight + 'px');

      try {
        if (this.options['closeable'] && sessionStorage.getItem('AnnoucementClosed') === null) {
          this._openAnnoucement();
        }
      } catch (error) {}

      this._bindEventsListeners();
      this._initRotator();
    }

    disconnectedCallback() {
      if (this.delegateElement) this.delegateElement.destroy();
      if (this._rotatorInterval) clearInterval(this._rotatorInterval);
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '[data-action="close-annoucement"]', this._closeAnnoucement.bind(this));
    }

    _openAnnoucement() {
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', document.getElementById('AnnouncementBar').offsetHeight + 'px');
    }

    _closeAnnoucement() {
      sessionStorage.setItem('AnnoucementClosed', 'true');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', '0px');
      if (this._rotatorInterval) clearInterval(this._rotatorInterval);
    }

    _initRotator() {
      const messages = this.querySelectorAll('.Announcement__Message');
      if (messages.length <= 1) return;

      const speed = (this.options['rotation_speed'] || 5) * 1000;
      this._currentIndex = 0;

      this._rotatorInterval = setInterval(() => {
        const allMessages = this.querySelectorAll('.Announcement__Message');
        const current = allMessages[this._currentIndex];

        current.style.opacity = '0';

        setTimeout(() => {
          current.classList.remove('is-active');
          current.style.display = 'none';
          current.style.opacity = '';

          this._currentIndex = (this._currentIndex + 1) % allMessages.length;
          const next = allMessages[this._currentIndex];

          next.style.display = 'block';
          next.style.opacity = '0';

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              next.classList.add('is-active');
              next.style.opacity = '';
            });
          });
        }, 500);
      }, speed);
    }
  }

  customElements.define('section-announcement-bar', TG_SectionAnnouncementBar);
}